export const MOBILE_APPS = 'mobile-apps';
export const APP_ICON = 'app-icon';
